import { useState, useEffect, useRef } from "react";
import * as Sentry from "@sentry/react";
import { ListaMaquinasByTienda } from "@/hooks/useMaquinas";

// Estado + fetch compartido por el modal "ver ubicaciones de una empresa"
// (ModalUbicacionesPorEmpresa / ModalUbicacionesPorOferta), usado desde
// Carrusel.jsx y OfertaDelDia.jsx.
export const useEmpresaLocations = () => {
  const [show, setShow] = useState(false);
  const [empresaId, setEmpresaId] = useState('');
  const [listaComunas, setListaComunas] = useState([]);
  const { mutateAsync: comunasMutateAsync } = ListaMaquinasByTienda();
  // `reqIdRef` da "last-wins": sólo la respuesta cuya solicitud es la más
  // reciente actualiza `listaComunas`, así que un doble clic rápido entre
  // banners de empresas distintas nunca deja el select de comunas con datos
  // de una empresa que ya no es la seleccionada. Mismo patrón que
  // useMaquinasPorComuna.js.
  const reqIdRef = useRef(0);

  useEffect(() => {
    if (empresaId != '') {
      const reqId = ++reqIdRef.current;

      comunasMutateAsync(empresaId)
        .then((data) => {
          if (reqIdRef.current !== reqId) return; // respuesta obsoleta: descartada en silencio
          setListaComunas(Array.isArray(data) ? data : []);
        })
        .catch((error) => {
          if (reqIdRef.current !== reqId) return; // respuesta obsoleta: descartada en silencio
          setListaComunas([]);
          Sentry.captureException(error, { tags: { feature: "ubicaciones_modal" } });
        });
    }
  }, [empresaId, comunasMutateAsync]);

  // `queryClient.removeQueries(['ListaMaquinasByTienda'])` era un no-op: la
  // key real que escribe ListaMaquinasByTienda es ['listaMaquinasTienda']
  // (useMaquinas.js), no ['ListaMaquinasByTienda'] — decisión explícita:
  // eliminar la llamada en vez de corregir la key, no hay ninguna razón
  // funcional para invalidar ese cache al abrir el modal (ver CLAUDE.md).
  // `comunasMutateAsync(0)` tampoco tenía un propósito funcional: disparaba
  // un segundo GET .../MaquinasActivas?empresa_id=0 en carrera con el fetch
  // útil del useEffect de arriba (mismo empresaId).
  const handleClick = (id) => {
    setEmpresaId(id);
    setShow(true);
  };

  return { show, setShow, empresaId, listaComunas, setListaComunas, handleClick };
};
